import { Component } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ValueFormatterParams } from 'ag-grid-community';

/**
 * currency-cell
 */
@Component({
	template: '{{ params.value | currency }}'
})
export class CurrencyComponent implements ICellRendererAngularComp {
	public params: ValueFormatterParams;

	public agInit(params: ValueFormatterParams): void {
		this.params = params;
	}

	public refresh(): boolean {
		return false;
	}
}
